// Registre central des catégories de l'agenda.
// Une catégorie = un `type` de Rdv. Pilote la couleur, le libellé, et (plus
// tard) la route vers l'objet métier concrétisé.
//
// Aligné sur le modèle Rdv global décidé côté backend :
//   type ∈ { depannage, atelier, location, autre }
import { COLORS } from "../../utilities/Constants"

export const CATEGORIES = {
	depannage: {
		key: "depannage",
		label: "Dépannage",
		color: COLORS.accent, // #2563EB
		bg: COLORS.accentLight, // #EFF6FF
		// route vers l'objet concrétisé (DepMission) une fois disponible
		route: (rdv) => (rdv.link ? rdv.link : null),
	},
	atelier: {
		key: "atelier",
		label: "Atelier",
		color: COLORS.warning, // #D97706
		bg: COLORS.warningLight, // #FFFBEB
		route: (rdv) => (rdv.link ? rdv.link : null),
	},
	location: {
		key: "location",
		label: "Location",
		color: COLORS.success, // #16A34A
		bg: COLORS.successLight, // #F0FDF4
		route: (rdv) => (rdv.link ? rdv.link : null),
	},
	autre: {
		key: "autre",
		label: "Autre",
		color: COLORS.textMuted, // #78716C
		bg: "#EFEDE9",
		route: (rdv) => (rdv.link ? rdv.link : null),
	},
}

// Ordre d'affichage (togglers, légende…).
export const CATEGORY_ORDER = ["depannage", "atelier", "location", "autre"]

// Fallback robuste si un type inconnu arrive de l'API.
export const getCategory = (type) => CATEGORIES[type] || CATEGORIES.autre
